import { SUPABASE_URL, SUPABASE_ANON_KEY } from "../config/env";

export async function supaFetch(path, token, opts = {}) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1${path}`, {
    ...opts,
    headers: {
      apikey: SUPABASE_ANON_KEY,
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      ...(opts.headers || {}),
    },
  });
  if (opts.method === "DELETE") return null;
  if (!res.ok) {
    // Don't let an error body (e.g. a 401 from an expired token, or a PostgREST 4xx) flow
    // into component state as if it were data — it would silently fail every downstream
    // Array.isArray check and look like "no rows". Log once and return null so callers can
    // keep their existing state.
    let detail = "";
    try { detail = await res.text(); } catch {}
    console.warn(`supaFetch ${res.status} on ${path}${detail ? ` — ${detail.slice(0, 200)}` : ""}`);
    return null;
  }
  return res.json();
}
